const toCartProductsMap = (cartProductsMap) => {
    if (!cartProductsMap) {
        return {};
    }
    return cartProductsMap;
};
const toExceededRuleIds = (exceededPriceRules = []) => {
    return new Set(exceededPriceRules
        .map((rule) => rule.id)
        .filter((id) => id !== null && id !== undefined)
        .map((id) => id.toString()));
};
export const createOrderBuildSession = ({ cartProductsMap, exceededPriceRules, isRootProductMenu, }) => {
    const hasCartProductsMap = !!cartProductsMap && Object.keys(cartProductsMap).length > 0;
    return {
        cartProductsMap: toCartProductsMap(cartProductsMap),
        hasCartProductsMap,
        qualifiedDiscountUsage: {},
        exceededPriceRuleIds: toExceededRuleIds(exceededPriceRules),
        isRootProductMenu,
    };
};
export const ensureOrderBuildSession = (session, params) => {
    if (session) {
        return session;
    }
    return createOrderBuildSession(params);
};
